module.exports = __webpack_public_path__ + "static/media/1.40a3f53e.JPG";